let intlInstance = null;

/**
 * Sets the intl instance. Should be called once in a top-level component.
 * @param {IntlShape} intl - The intl instance from react-intl
 */
export const setIntl = intl => {
  intlInstance = intl;
};

/**
 * Retrieves the intl instance.
 * @returns {IntlShape} The intl instance
 * @throws Will throw an error if intl is not set
 */
export const getIntl = () => {
  if (!intlInstance) {
    throw new Error("Intl not initialized. Please ensure IntlProvider is set up correctly.");
  }
  return intlInstance;
};
